import React, {useEffect, useState} from "react";
import FunctionsData from "../../Functions/FunctionsData";
import AnimalSingleForm from "../Landing/AnimalSingleForm";
import {Button} from "@mui/material";

export default function CommunityStep2({microchipOnly,inspectors,outreach, accounts,aStep, setAStep, cmpId, animals, setAnimals, setFrmCampaign, frmEmail, postCode}) {

    const [loadingVoucher, setLoadingVoucher] = useState(true);
    const [availableVoucherNumbers, setAvailableVoucherNumbers] = useState([]);
    const [loadingVoucherCount, setLoadingVoucherCount] = useState(true);
    const [availableVoucherCount, setAvailableVoucherCount] = useState(0);
    const [vouchersByEmail, setVouchersByEmail] = useState(999);
    const [currentAnimal, setCurrentAnimal] = useState(0);
    const [blocked, setBlocked] = useState(true);
    const [showAddButton, setShowAddButton] = useState(false);
    const [isSpca, setIsSpca] = useState(false);
    const [btnEnabled,setButtonEnabled] = useState(true);
    const [btnEnabledDup,setButtonEnabledDup] = useState(true);
    const groupIds = accounts[0].idTokenClaims.groups ? accounts[0].idTokenClaims.groups.join(',') : '';

    useEffect(() => {
        setIsSpca(frmEmail.toLowerCase().includes('@spca.nz') || frmEmail.toLowerCase().includes('@datasourcery.com'));
    }, [frmEmail])


    useEffect(() => {
        FunctionsData.postDataReturn(
            '/api/campaign/' + (outreach
                ? 'outreach'
                : inspectors
                  ? 'inspectors'
                  : 'community') + '/postcodes/' + postCode,
            {groups:groupIds}
        ).then((r) => {
            setAvailableVoucherCount(r)
        }).then((r) => {
            setLoadingVoucherCount(false);
        })
    },[loadingVoucherCount])

    useEffect(() => {
        FunctionsData.postDataReturn(
            '/api/campaign/' + (outreach
                ? 'outreach'
                : inspectors
                  ? 'inspectors'
                  : 'community') + '/vouchers/postcodes/' + postCode,
            {groups:groupIds,
                cmpid:cmpId
            }
        ).then((r) => {
            console.log(r)
            setAvailableVoucherNumbers(r)
        }).then((r1) => {
            setLoadingVoucher(false)
        })

        FunctionsData.fetchDataGetNoLoading(
            '/api/voucher/vouchers_issued/' + frmEmail,
            setVouchersByEmail
        )

    }, [loadingVoucher]);

    useEffect(() => {
        console.log('animals',animals)
        let arr = animals;
        let show = true;
        for (let x in arr) {
            if (arr[x]['a_source'] === '' || arr[x]['a_source'] === 'gender' || arr[x]['a_age'] === '') {
                show = false;
            }
        }

        if (arr.length === 0) {
            setShowAddButton(true);
        } else {
            setShowAddButton(show);
        }

    }, [animals])

    async function removeAnimal(id, sn) {

        let arr = animals;
        let newArr = [];
        for (let x in arr) {
            if (arr[x]['id'] !== id) {
                newArr.push(arr[x]);
            }
        }

        const tkn = await FunctionsData.getCSRFToken();
        await fetch(FunctionsData.getApiUrl('/api/voucher/unblock/') + sn, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'token': sessionStorage.tkn,
                'X-CSRF-Token': tkn.csrf
            }
        })
        // .then((res) => {return res.json()})
        // .then((d) => {toast('Animal removed')});

        for (let x in newArr) {
            newArr[x]['id'] = x;
        }

        if (currentAnimal == id && newArr.length > 0) setCurrentAnimal(newArr[0]['id']);

        setAnimals(newArr);
        setLoadingVoucher(true);

        window.gtag('event', 'action', {
            category: 'User',
            action: 'Removed animal'
        });

    }

    const AnimalBlock = (props) => {
        return (
            <div>
                {animals.map((d, idx) => {
                    return (
                        <AnimalSingleForm
                            key={idx}
                            rowBase={d}
                            animals={animals}
                            setAnimals={setAnimals}
                            currentAnimal={currentAnimal}
                            setCurrentAnimal={setCurrentAnimal}
                            removeAnimal={removeAnimal}
                            blocked={blocked}
                            setBlocked={setBlocked}
                            frmEmail={frmEmail}
                            community
                            microchipOnly={microchipOnly}
                        />
                    )
                })}
            </div>
        )
    }

    async function refreshVouchersCount() {
        console.log('refreshVouchersCount: inspectors',inspectors)
        return await FunctionsData.postDataReturn(
            '/api/campaign/'  + (
                outreach
                    ? 'outreach'
                    : inspectors
                        ? 'inspectors'
                        : 'community'
            ) + '/postcodes/' + postCode,
            {groups:groupIds}
        ).then((r) => {
            return (r)
        })
    }

    async function refreshVouchers() {

        console.log('refreshVouchers: inspectors',inspectors)
        return await FunctionsData.postDataReturn(
            '/api/campaign/' + (outreach
                ? 'outreach'
                : inspectors
                  ? 'inspectors'
                  : 'community') + '/vouchers/postcodes/' + postCode,
            { groups: groupIds,cmpid:cmpId }
        ).then((r) => {
            return r;
        });
    }

    async function addAnimal(lastAnimal = false) {

        const l = animals.length;
        const refreshedVouchers = await refreshVouchers();
        const refreshedVouchersCount = await refreshVouchersCount();
        setAvailableVoucherCount(refreshedVouchersCount);
        setAvailableVoucherNumbers(refreshedVouchers);

        if (refreshedVouchers.length > 0 && refreshedVouchersCount > 0) {

            const voucher = refreshedVouchers[0];
            if(animals.filter(({voucher}) => voucher === refreshedVouchers[0]).length > 0) return false;

            // const existingVouchers = availableVoucherNumbers.filter(({id}) => id !== voucher.id);
            // setAvailableVoucherNumbers([...existingVouchers]);

            setFrmCampaign(voucher.campaign_id);
            await FunctionsData.postData(
                '/api/voucher/block/' + voucher.id,
                {
                    blocked_at: "current_timestamp()"
                }
            )

            setAvailableVoucherCount(await refreshVouchersCount());

            await fetch(FunctionsData.getApiUrl('/api/media/barcode/') + voucher.id,
                {
                    method: 'GET',
                    headers: {'Content-Type': 'application/json', 'token': sessionStorage.tkn}
                }
            ).then(r => {
            });

            // console.log('convertUTCToLocalTime',convertUTCToLocalTime(voucher.expiry_date));

            let a = {};
            if(!lastAnimal) {
                a = {
                    name: null,
                    gender: "",
                    animal_type: "Cat",
                    id: (l + 1),
                    voucher: voucher.id,
                    voucher_id: voucher.rowid,
                    campaign_id: voucher.campaign_id,
                    expiry_date: voucher.expiry_date,
                    is_microchipped: false,
                    is_pregnant: false,
                    was_pregnant: false,
                    a_is_owner: false,
                    a_is_stray: false,
                    a_part_colony: false,
                    a_age: '',
                    a_color_primary: '',
                    a_color_secondary: '',
                    a_source: '',
                    a_microchip_only_flag: microchipOnly ? true : false,

                }
            }else{
                a = {...lastAnimal,voucher: voucher.id,voucher_id: voucher.rowid, id:(l+1),gender:"", name:null}
            }

            let newArr = animals;
            newArr.push(a);

            console.log('setAnimals', newArr)
            setAnimals(newArr);
            setCurrentAnimal(l + 1);

            window.gtag('event', 'action', {
                category: 'User',
                action: 'Added new animal'
            });

        }

    }

    return (
        <div>
            <div className={"form"} style={{textAlign: 'left'}}>

            <h3 style={{ marginBottom: 20 }}>
  Please enter the details of every animal you would like to book in for{' '}
  {outreach ? 'desexing' : 'community desexing'}.&nbsp;
  {(availableVoucherCount < 25 && availableVoucherCount > 0) && (
    <>
      This campaign is almost sold out. There are only {availableVoucherCount} vouchers available. Please email{' '}
      <a href="mailto:snipnchip@spca.nz" target="_blank" rel="noopener">
        snipnchip@spca.nz
      </a>{' '}
      if you require further assistance.
    </>
  )}
</h3>

                <AnimalBlock animals={animals} setAnimals={setAnimals}
                             frmEmail={frmEmail}
                             availableVoucherCount={availableVoucherCount}/>

                <ShowAddButton {...{animals,availableVoucherNumbers,addAnimal,availableVoucherCount,blocked,showAddButton,btnEnabled,btnEnabledDup}} />

                <Button
                    onClick={() => setAStep(aStep + 1)}
                    sx={{marginTop: '20px', width: '100%'}} variant={"contained"}
                    disabled={
                        (
                            animals.length === 0 || (blocked === true)
                        )
                    }
                >
                    Next: Finalise your voucher order
                </Button>

            </div>

            <Button size="full" variant={""}
                    onClick={() => setAStep(aStep - 1)}
                    sx={{margin: 1}}>Back
            </Button>
        </div>
    )
}

const ShowAddButton = ({animals,availableVoucherNumbers,addAnimal,availableVoucherCount,blocked,showAddButton,btnEnabledDup, btnEnabled}) => {

    // console.log('availableVoucherNumbers',availableVoucherNumbers);
    let availableVouchers = availableVoucherNumbers.length - animals.length;

    function getNewAnimal(e) {
        e.target.disabled = true;
        addAnimal().then(() => {
            setTimeout(() => {
                e.target.disabled = false;
            }, 3000);
        });
    }

    function duplicateAnimal(e) {
        e.target.disabled = true;
        if(animals.length > 0 && e.target.disabled) {
            let ix = animals.length -1;
            let lastAnimal = animals[ix];
            addAnimal(lastAnimal).then(() => {
                setTimeout(() => {
                    e.target.disabled = false;
                }, 3000);
            });
        }
    }

    if (availableVoucherNumbers.length === 0) return (
        <>
            This campaign has now sold out. Please email <a href={"mailto:snipnchip@spca.nz"} target={"_blank"}>snipnchip@spca.nz</a> and our Desexing Team will be able to provide other options for you.
        </>
    )

    return (
        <div>
            <Button size="small"
                    onClick={getNewAnimal}
                    style={{margin: 0, marginTop: 1, background: '#12C7B9'}} variant={"contained"}
                    disabled={!btnEnabled || !(availableVouchers > 0) || (blocked === true && showAddButton === false) || (availableVoucherCount ===0)}
            >
                {
                    (animals.length > 0) ?
                        "Add another animal (" + availableVouchers + " available)" :
                        "Add your animal (" + availableVouchers + " available)"
                }
            </Button>
            {
                (animals.length > 0) ?
                    <Button size="small"
                            onClick={duplicateAnimal}
                            style={{margin: 0, marginLeft:5, marginTop: 1, background: '#12C7B9'}} variant={"contained"}
                            disabled={!btnEnabled || !btnEnabledDup || !(availableVouchers > 0) || (blocked === true && showAddButton === false) || (availableVoucherCount ===0)}
                    >
                        Duplicate
                    </Button>
                    : null
            }
        </div>

    )
}
